'use client';
import { IRepository } from '@/types';
import { IEvaluation } from '@/lib/evaluationsApi';
import * as Styled from './styled';
import {
  SourceFileInfo,
  TargetFileInfo,
} from '@/components/Repository/Evaluations/EvaluationWizard/EvaluationFileInfo';
import * as Icon from '@/ui/Icon';

const SourceTargetFiles: React.FC<{ repository: IRepository; evaluation: IEvaluation }> = ({
  repository,
  evaluation,
}) => {
  return (
    <Styled.SourceTargetFiles>
      <div>
        {/* <div className="title">Input source:</div> */}
        <SourceFileInfo evaluation={evaluation} repository={repository} className="mono file-name" />
      </div>
      {!evaluation.is_sample && (
        <>
          <div style={{ flex: 0, minWidth: 50, textAlign: 'center' }}>
            <Icon.ArrowRight />
          </div>
          <div>
            {/* <div className="title">Output destination:</div> */}
            <TargetFileInfo evaluation={evaluation} repository={repository} className="mono file-name" />
          </div>
        </>
      )}
    </Styled.SourceTargetFiles>
  );
};

export default SourceTargetFiles;
